import * as angular from 'angular';

function onlyLetters(): ng.IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        link(scope: ng.IScope, element: JQLite, attr: ng.IAttributes, ctrl: ng.IController) {
            if (!ctrl) { return; }
            function inputValue(val: any) {
                if (val) {
                    const transformedInput = val.replace(/[^a-zA-Z]/g, '');
                    if (transformedInput !== val) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                } else {
                    return '';
                }
            }
            ctrl.$parsers.push(inputValue);
        }
    };
}

angular
    .module('app.common')
    .directive('onlyLetters', onlyLetters);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/only-letters.directive.ts